/**
 * This function is exported as default. It initializes the accordion functionality.
 */
export default () => {
	// Select all sections of the accordion
	const sections = document.querySelectorAll('.govuk-accordion__section');

	// Loop through each section
	sections.forEach(function (section) {
		// Find the button within each section
		const button = section.querySelector(
			'.govuk-accordion__section-button'
		);

		// Find the icon for expansion within each section
		const plusIcon = section.querySelector('.govuk-accordion__icon--plus');

		// Find the icon for collapse within each section
		const minusIcon = section.querySelector(
			'.govuk-accordion__icon--minus'
		);

		// Find the content within each section
		const content = section.querySelector(
			'.govuk-accordion__section-content'
		);

		// Add event listener for click event on each section's button
		button.addEventListener('click', function () {
			// Check if the section is currently expanded
			const isExpanded = button.getAttribute('aria-expanded') === 'true';

			// Toggle the aria-expanded attribute to reflect the new state
			button.setAttribute('aria-expanded', String(!isExpanded));

			// Toggle visibility of the plus icon based on the new state
			plusIcon.classList.toggle('hidden', !isExpanded);

			// Toggle visibility of the minus icon based on the new state
			minusIcon.classList.toggle('hidden', isExpanded);

			// Toggle visibility of the content based on the new state
			content.hidden = !content.hidden;
		});
	});
};
